import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, ContentChildren } from '@angular/core';
import { AmdNavbarItemComponent } from './navbar-item/navbar-item.component';
export class AmdNavbarComponent {
    /**
     * @param {?} changeDetectorRef
     */
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.navbarThemeClass = 'amd-navbar--default';
        this._theme = 'default';
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set theme(theme) {
        this.navbarThemeClass = `amd-navbar--${theme}`;
        this._theme = theme;
        this.setThemeOnChildren();
    }
    /**
     * @param {?} navbarItems
     * @return {?}
     */
    set navbarItems(navbarItems) {
        this._navbarItems = navbarItems;
        this.setThemeOnChildren();
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.setThemeOnChildren();
    }
    /**
     * @return {?}
     */
    setThemeOnChildren() {
        if (this._navbarItems) {
            this._navbarItems.forEach((item) => {
                item.theme = this._theme;
            });
        }
        this.changeDetectorRef.markForCheck();
    }
}
AmdNavbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-navbar',
                template: "<div class=\"amd-navbar\" [ngClass]=\"navbarThemeClass\"> <ng-content></ng-content> </div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
AmdNavbarComponent.ctorParameters = () => [
    { type: ChangeDetectorRef, },
];
AmdNavbarComponent.propDecorators = {
    'theme': [{ type: Input },],
    'navbarItems': [{ type: ContentChildren, args: [AmdNavbarItemComponent, { descendants: true },] },],
};
function AmdNavbarComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarComponent.ctorParameters;
    /** @type {?} */
    AmdNavbarComponent.propDecorators;
    /** @type {?} */
    AmdNavbarComponent.prototype.navbarThemeClass;
    /** @type {?} */
    AmdNavbarComponent.prototype._navbarItems;
    /** @type {?} */
    AmdNavbarComponent.prototype._theme;
    /** @type {?} */
    AmdNavbarComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=navbar.component.js.map
//# sourceMappingURL=navbar.component.js.map
